import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const freshRss = defineConnector({
  identifier: "freshRss",
  name: "FreshRSS",
  tagLine: "Self-hosted RSS feed aggregator",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: customAuth("freshRss"),
  steps: [
    {
      title: "Enter your FreshRSS server URL",
      items: [
        {
          kind: "baseUrl",
          label: "Server URL",
          required: true,
          placeholder: "https://freshrss.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your FreshRSS instance.",
        },
      ],
    },
    {
      title: "Enable and configure API access",
      items: [
        {
          kind: "markdown",
          content:
            "In FreshRSS, go to **Settings → Profile** and set an **API password**. This is separate from your login password.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "API password",
          required: true,
          target: { kind: "secrets", field: "apiPassword" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl}/api/greader.php/reader/api/0/tag/list?output=json`,
  },
});
